import request from '@/utils/request'

const cassApi = {
  autoLogin: (data, appCode, ts, sign) => {
    return request({
      url: `/public/cass/auto-login?appCode=${appCode}&ts=${ts}&sign=${sign}`,
      method: 'post',
      data
    })
  }
}

export default cassApi
